enum UtmSources {
    facebook = 'facebook'
}

export { UtmSources }